import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, RefreshCw, Zap } from 'lucide-react';
export function TrustSection() {
  const features = [{
    icon: Shield,
    title: 'Compra protegida por Hotmart',
    desc: 'La plataforma #1 de productos digitales en Latinoamérica'
  }, {
    icon: Lock,
    title: 'Pago 100% seguro',
    desc: 'Tarjeta de crédito, débito, transferencia bancaria, efectivo y más métodos locales'
  }, {
    icon: RefreshCw,
    title: 'Garantía de 7 días',
    desc: 'Si no te sirve, Hotmart te devuelve el dinero. Sin preguntas.'
  }, {
    icon: Zap,
    title: 'Acceso inmediato',
    desc: 'Recibes todo en tu email apenas completas el pago'
  }];
  return <section className="py-12 bg-[#4a7c2c]/5 border-y border-[#4a7c2c]/10" data-id="element-278">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-279">
        <div className="text-center mb-10" data-id="element-280">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-281">
            Tu compra está 100% protegida
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-10" data-id="element-282">
          {features.map((feature, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex flex-col items-center text-center p-4" data-id="element-283">
              <div className="w-12 h-12 rounded-full bg-white shadow-sm flex items-center justify-center mb-4 text-[#4a7c2c]" data-id="element-284">
                <feature.icon className="w-6 h-6" data-id="element-285" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-286">{feature.title}</h3>
              <p className="text-sm text-gray-600" data-id="element-287">{feature.desc}</p>
            </motion.div>)}
        </div>

        <div className="flex justify-center" data-id="element-288">
          <img src="https://cdn.magicpatterns.com/uploads/k9x8JCcUwfWxsaEMNBiB2R/Hotmart_logo.svg.png" alt="Hotmart" className="h-8 opacity-80 grayscale hover:grayscale-0 transition-all duration-300" data-id="element-289" />
        </div>
      </div>
    </section>;
}